import { useState } from 'react';

import { RevenueProps } from 'pages/leads/pages/revenues/revenues-page.types';
import { useTranslation } from 'react-i18next';

import { Button } from '@olist/design-system';
import { Box, Loading } from '@olist/united';

import { InvalidRevenue } from './components/invalid-revnue-alert';
import SegmentDropdown from './components/revenue-dropdown';

interface RevenuesFormProps {
  isSubmittingForm: boolean;
  onChange: (revenue: RevenueProps) => void;
  onAnswer: (revenue: RevenueProps) => void;
}

const RevenuesForm = ({ isSubmittingForm, onAnswer, onChange }: RevenuesFormProps) => {
  const { t } = useTranslation();

  const [selectedRevenue, setSelectedRevenue] = useState<RevenueProps | null>(null);
  const isSegmentsEmpty = !selectedRevenue;
  const isInvalidOption = selectedRevenue?.range === 'até 7000';
  const isContinueBtnDisabled = isSegmentsEmpty || isInvalidOption;

  const handleOnAnswer = () => {
    if (isContinueBtnDisabled) {
      return;
    }
    onAnswer(selectedRevenue);
  };

  const handleOnChangeRevenues = (revenueChanged: RevenueProps) => {
    if (revenueChanged) {
      onChange(revenueChanged);
    }
    setSelectedRevenue(revenueChanged);
  };

  return (
    <>
      <Box>
        <SegmentDropdown onChangerRevenues={handleOnChangeRevenues} />
      </Box>
      <Box mt={4}>
        <Button
          data-ref="continue-button"
          type="submit"
          disabled={isContinueBtnDisabled}
          variation="primary"
          onClick={handleOnAnswer}
        >
          {isSubmittingForm ? <Loading variation="shadow" /> : t`next`}
        </Button>

        {isInvalidOption && <InvalidRevenue />}
      </Box>
    </>
  );
};

export default RevenuesForm;
